<template>
  <div class="operator-permissions">
    <operator-base-permission-group
      v-for="(_, permissionGroupKey) in permissionsByGroup"
      :key="permissionGroupKey"
      :title="capitalize(permissionGroupKey)"
      :enabled-permissions="enabledPermissionsByGroup[permissionGroupKey]"
      :permission-options="permissionsByGroup[permissionGroupKey]"
      :readonly="readonly"
      @update-group="$emit('update-permissions', $event)"
    />
  </div>
</template>

<style lang="scss" scoped>
  .operator-base-permission-group:first-child {

    -webkit-border-top-left-radius: 4px;
    -webkit-border-top-right-radius: 4px;
    -moz-border-radius-topleft: 4px;
    -moz-border-radius-topright: 4px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .operator-base-permission-group:last-child {
    -webkit-border-bottom-right-radius: 4px;
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-bottomright: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
</style>

<script>
import OperatorBasePermissionGroup from './OperatorBasePermissionGroup.vue';
import { capitalize } from 'lodash'

export default {
  components: {
    OperatorBasePermissionGroup
  },
  props: {
    operator: {
      type: Object,
      default: () => ({})
    },
    permissionsByGroup: {
      type: Object,
      default: () => ({})
    },
    readonly: Boolean,
  },
  emits: ['update-permissions'],
  computed: {
    enabledPermissionsByGroup () {
      const groupedPermissions = {}
      for (const group in this.permissionsByGroup) {
        groupedPermissions[group] = {}

        for (const permission of this.permissionsByGroup[group]) {
          const value = this.operator.permission[permission.key]
          if (permission.type !== 'boolean' || !value) {
            continue
          }

          groupedPermissions[group][permission.key] = permission.name
        }
      }

      return groupedPermissions
    },
  },
  methods: {
    capitalize,
    getPermissionOptionsForGroup (group) {
      const permissions = {}

      for (const permission of this.permissionsByGroup[group]) {
        if (permission.type !== 'boolean') {
          continue
        }
        permissions[permission.key] = permission
      }

      return permissions
    }
  }
}
</script>
